import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import principle05 from "./layouts/principle-05/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "ca09dc07-517e-4b46-89d5-4cdeb5b54f00",
  publicId: "29",
  name: "Interactive VR systems",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, principle03, principle04, principle05, task01],
};

export default lesson;
